import { IParagraph, ParagraphType, IContentGroupParagraph, IContentGroupItem, IVenueCardParagraph, IVenueInfo } from "types";

type ArticleParagraphProps = IParagraph | IContentGroupParagraph | IVenueCardParagraph;

const ArticleParagraph = (props: ArticleParagraphProps) => {
  const { type } = props;

  if (type === ParagraphType.IMAGE) {
    const { content } = props as IParagraph;
    return (
      <div className="flex justify-center">
        <img src={content} alt="" />
      </div>
    );
  }

  if (type === ParagraphType.TEXT) {
    const { content } = props as IParagraph;
    return <div className="whitespace-pre-line break-all" dangerouslySetInnerHTML={{ __html: content }} />;
  }

  if (type === ParagraphType.CONTENT_GROUP) {
    const { groups } = props as IContentGroupParagraph;
    return (
      <div>
        {groups.map((group: IContentGroupItem, groupIndex: number) => (
          <div key={groupIndex} className="mb-4">
            {/* 條件渲染標題 - 只有當 title 存在且不為空時才渲染 */}
            {group.title && group.title.trim() !== '' && (
              <h3 className={`mb-2 ${group.title_style === 'bold' ? 'font-bold' : ''}`}>
                {group.title}
              </h3>
            )}
            
            {/* 列表項目 */}
            {group.items && group.items.length > 0 && (
              <ul className="list-disc pl-6 space-y-1">
                {group.items.map((item, itemIndex) => (
                  <li key={itemIndex}>
                    {item.link ? (
                      <a href={item.link} target="_blank" rel="noopener noreferrer" 
                         className="text-blue-600 hover:underline">
                        {item.text}
                      </a>
                    ) : (
                      <span className={item.bold ? 'font-bold' : ''}>{item.text}</span>
                    )}
                    {item.description && (
                      <span className="text-gray-600 text-sm ml-2">- {item.description}</span>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    );
  }

  if (type === ParagraphType.VENUE_CARD) {
    const { venues } = props as IVenueCardParagraph;
    return (
      <div className="space-y-4">
        {venues.map((venue: IVenueInfo, venueIndex: number) => (
          <div key={venueIndex} className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
            {/* 場館名稱 */}
            <h3 className="text-lg font-bold mb-3 text-gray-800 border-b border-gray-100 pb-2">
              {venue.name}
            </h3>
            
            {/* 場館資訊 */}
            <div className="space-y-2">
              {/* 連絡電話 */}
              {venue.phone && (
                <div className="flex items-center text-gray-700">
                  <span className="mr-2">📞</span>
                  <span>{venue.phone}</span>
                </div>
              )}
              
              {/* 預約連結 */}
              {venue.booking_link && (
                <div className="flex items-center">
                  <span className="mr-2">🔗</span>
                  <a href={venue.booking_link.url} target="_blank" rel="noopener noreferrer" 
                     className="text-blue-600 hover:underline">
                    {venue.booking_link.text}
                  </a>
                </div>
              )}
              
              {/* 地址 */}
              {venue.address && (
                <div className="flex items-start text-gray-700">
                  <span className="mr-2 mt-0.5">📍</span>
                  <div className="flex-1">
                    {venue.address_map ? (
                      <a href={venue.address_map} target="_blank" rel="noopener noreferrer" 
                         className="text-blue-600 hover:underline">
                        {venue.address}
                      </a>
                    ) : (
                      <span>{venue.address}</span>
                    )}
                  </div>
                </div>
              )}
              
              {/* Facebook 粉絲專頁 */}
              {venue.facebook && (
                <div className="flex items-center">
                  <span className="mr-2">👥</span>
                  <a href={venue.facebook.url} target="_blank" rel="noopener noreferrer" 
                     className="text-blue-600 hover:underline">
                    {venue.facebook.text}
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default ArticleParagraph;
